import { cn } from '@aw/lib'
import { SVGProps } from 'react'

type Props = {
    className?: string
    color?: string  //default = "#30343F"
} & SVGProps<SVGSVGElement>


function XMarkIcon({ className, color = "var(--icon-fg, #30343F)", ...props }: Props) {
    return (
        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"

            className={cn(className)}
            color={color}
            {...props}
        >
            <path d="M315.31 411.31C309.056 417.563 298.936 417.563 292.682 411.31L160 278.627L27.318 411.31C21.064 417.563 10.944 417.563 4.69 411.31C-1.563 405.056 -1.563 394.936 4.69 388.682L137.373 256L4.69 123.318C-1.563 117.064 -1.563 106.944 4.69 100.69C10.944 94.437 21.064 94.437 27.318 100.69L160 233.373L292.682 100.69C298.936 94.437 309.056 94.437 315.31 100.69C321.563 106.944 321.563 117.064 315.31 123.318L182.627 256L315.31 388.682C321.563 394.936 321.563 405.056 315.31 411.31Z"
                color={color}
            />
        </svg>
    )

}
export default XMarkIcon


